import moment from 'moment';
import { useTranslation } from "react-i18next";
import { curStateAccount } from '../Redux/selector';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import imgImage495 from "../assets/web-v3-images/f28140f4f37c217cbdee8b7decbaccc0646922b7.png";
import imageCancel from "../assets/web-v3-images/ButtonCancel.png";
import { formatDataNumberToen } from "@/utils/helper";
import { ComponentBestSaler } from "@/page/components/Package";

function ItemPackage({ data, type, isRegister = false, handelSelectItem }) {
	const { t, i18n } = useTranslation();
	const selectorAccount = useSelector(curStateAccount)
	const [currentpackage, setCurrentPackage] = useState([])
	const text = t('account_page.package.title_bid_retail').replace("_NUMBER_", data?.max_turn);
	let textHeader = {
		header: t('header.bid'),
		description: text
	}
	if (type !== "SUB" && data?.pack_id === "BID") {
		textHeader.description = t('account_page.package.title_bid_retail_1').replace("_NUMBER_", data?.max_turn)
	}
	if (type === "SUB") {
		if (data.pack_id === "REVERSE_DAILY") {
			textHeader.header = t('account_page.package.daily')
			if (i18n.language === "my") {
				textHeader.description = t('account_page.package.title_bid_sub').replace("_NUMBER_", data?.max_turn).replace("_CYCLE_", "တစ်နေ့လျှင် အလှည့်").replace("_FOOTER_TIMER_", "ကြိမ်")
			} else {
				textHeader.description = t('account_page.package.turns_per_day').replace("_NUMBER_", data?.max_turn)
			}
		}
		if (data.pack_id === "REVERSE_WEEKLY") {
			textHeader.header = t('account_page.package.weekly')
			if (i18n.language === "my") {
				textHeader.description = t('account_page.package.title_bid_sub').replace("_NUMBER_", data?.max_turn).replace("_CYCLE_", "တစ်ပတ်လျှင် အလှည့်").replace("_FOOTER_TIMER_", "ကြိမ်")
			} else {
				textHeader.description = t('account_page.package.turns_per_week').replace("_NUMBER_", data?.max_turn)
			}
		}
		if (data.pack_id === "REVERSE_MONTHLY") {
			textHeader.header = t('account_page.package.monthly')
			if (i18n.language === "my") {
				textHeader.description = t('account_page.package.title_bid_sub').replace("_NUMBER_", data?.max_turn).replace("_CYCLE_", "တစ်လလျှင် အလှည့်").replace("_FOOTER_TIMER_", "ကြိမ်")
			} else {
				textHeader.description = t('account_page.package.turns_per_month').replace("_NUMBER_", data?.max_turn)
			}
		}
	}
	useEffect(() => {
		if (selectorAccount.remainTurn) {
			setCurrentPackage(selectorAccount.remainTurn)
		}
	}, [selectorAccount.remainTurn])
	const isCheckPackRegister = currentpackage?.some(
		(item) => item?.pack_id === data?.pack_id
	)
	const dataSub = currentpackage?.find(it => it.pack_id === data?.pack_id)
	const desc = textHeader.description || ""
	
	return (
		<div className="box-item-package relative flex justify-between items-center">
			{/* <div className="box-item-package-title"> */}
			{/* <div className="flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] relative shrink-0 text-[#772917] text-[32px] tracking-[0.32px]">
				<p className="leading-[normal]">{textHeader.description === text ? <></> : <span>{textHeader.header} - </span>}
				<span>{(type === "RETAIL" && data.pack_id !== "REVERSE_BID_1") ? desc.replace("Turn", "Turns") : textHeader.description}</span>
			</p></div> */}
			<div>
			<div className = {`font-['Inter:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#a15c07] ${i18n.language === "my" ? "text-[24px]" : "text-[28px]"} tracking-[0.28px] h-[48px]`}>
				<p className="leading-[normal]">{textHeader.description === text ? <></> : <span>{textHeader.header} - </span>}
				<span>{(type === "RETAIL" && data.pack_id !== "REVERSE_BID_1") ? desc.replace("Turn", "Turns") : textHeader.description}</span>
			</p>

			</div>
			<div className="box-item-package-content">
				<div className="box-item-package-content-info">
					{/* <div className="price">{`${data?.price / 100} MMK`}</div> */}
					<div className="flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] relative shrink-0 text-[#772917] text-[32px] tracking-[0.32px] mb-[10px]">
						<p className="leading-[normal]">{formatDataNumberToen(data?.price / 100)} MMK</p>
					</div>

					{type === "SUB" && isCheckPackRegister && <div className={`font-['Inter:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#a15c07] ${i18n.language === "my" ? "text-[24px]" : "text-[28px]"} tracking-[0.28px]`}>{t("account_page.package.description_sub").replace("_NUMBER_", data?.max_turn)}</div>}

					{type === "RETAIL" && <div className={`font-['Inter:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#a15c07] ${i18n.language === "my" ? "text-[24px]" : "text-[28px]"} tracking-[0.28px]`}>{t("account_page.package.description_retail")}</div>}

					{type === "SUB" && data.pack_id === "REVERSE_DAILY" && <div className={`font-['Inter:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#a15c07] ${i18n.language === "my" ? "text-[24px]" : "text-[28px]"} tracking-[0.28px]`}>{t("account_page.package.description_sub_day")}</div>}

					{type === "SUB" && data.pack_id === "REVERSE_WEEKLY" && <div className={`font-['Inter:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#a15c07] ${i18n.language === "my" ? "text-[24px]" : "text-[28px]"} tracking-[0.28px]`}>{t("account_page.package.description_sub_week")}</div>}

					{type === "SUB" && data.pack_id === "REVERSE_MONTHLY" && <div className={`font-['Inter:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#a15c07] ${i18n.language === "my" ? "text-[24px]" : "text-[28px]"} tracking-[0.28px]`}>{t("account_page.package.description_sub_month")}</div>}

					{type === "SUB" && isCheckPackRegister && dataSub && <div className={`font-['Inter:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#a15c07] ${i18n.language === "my" ? "text-[24px]" : "text-[28px]"} tracking-[0.28px]`}>{moment(dataSub.next_charge_time).format("DD/MM/YYYY    HH:mm:ss")}</div>}
				</div>
			</div></div>
				<div onClick={() => handelSelectItem(data, isCheckPackRegister ? true : false)} disabled={isRegister && !isCheckPackRegister} className="relative" style={{ pointerEvents: isRegister && !isCheckPackRegister ? "none" : "", opacity: isRegister && !isCheckPackRegister ? 0.5 : "" }}>
					{/*  className={`box-item-package-content-button ${type === "SUB" && isCheckPackRegister ? "btn-cancel" : ""}`} */}
					<div className="h-[80px] relative shrink-0 w-[172px] btn-click-active">
						<div
							className="absolute h-[80px] left-0 rounded-[999px] top-0 w-[172px]"
							data-name="image 494"
						>
							{isCheckPackRegister && type === "SUB" ? <img
							alt=""
							className="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[999px] size-full"
							src={imageCancel}
							style={{border: "1px solid #E04F16"}}
							/> : <img
							alt=""
							className="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[999px] size-full"
							src={imgImage495}
							/>
							}
						</div>
						<div className={` [word-break:break-word] absolute flex flex-col font-['Inter:Extra_Bold',sans-serif] font-extrabold justify-center leading-[0] left-1/2 -translate-x-1/2 not-italic ${isCheckPackRegister && type === "SUB" ? "text-[#E04F16] text-[26px]" : "text-[#fefbe8] text-[32px]"} top-1/2 tracking-[0.32px] whitespace-nowrap`}>
							{type === "SUB" && isCheckPackRegister ? t("account_page.package.cancel") : t("account_page.package.buy")}
						</div>
					</div>
				</div>
			{/* {data.best_seller ? <div className='icon-best-sale' /> : null} */}
			{data.best_seller ? <ComponentBestSaler /> : null}
		</div>
	);
}

export default ItemPackage;
